export default function EventCard({ contentTypeSlug = null, item, cdnUrl }) {
    const { title, tags } = item;
    let slug = item.slug;

    if (contentTypeSlug !== null) {
        if (item.slug.includes('/')) {
            slug = item.slug.split('/')[1];
        }
    }

    return (
        <div class="bg-white border hover:border-0 hover:shadow-2xl border-gray-200 shadow-sm dark:bg-gray-800 dark:border-gray-700">
            <a href={contentTypeSlug !== null ? `/${contentTypeSlug}/${slug}` : item?.slug} aria-label="Item Image Link">
                <div className="relative w-full h-[20rem] sm:h-[12rem] bg-cover" style={{
                    backgroundImage: `url('${cdnUrl}/images/${item?.meta?.preview_image}')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                }}>
                     { item?.tags?.length > 0 && <div className="absolute top-4 left-4 flex gap-2 flex-wrap">
                            { item?.tags?.map(tag => <span className="py-2 px-4 shadow-md no-underline rounded-full bg-gray-50 text-black font-sans font-semibold text-sm border-blue btn-primary hover:text-white hover:bg-blue-light focus:outline-none active:shadow-none mr-2">{ tag?.name }</span>) }    
                    </div>}    
                </div>
            </a>
            <div className="h-[calc(100%_-_20rem)] sm:h-[calc(100%_-_12rem)] px-5 py-5 flex flex-col justify-between">
                <div className="flex flex-col">
                    { title && <h2 class="mb-4 leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">{ title }</h2> }

                    { item?.meta?.preview_description && <p class="mt-3 mb-4 font-normal text-base text-gray-500 dark:text-gray-400">{ item?.meta?.preview_description?.substr(0, 200) }</p> } 
                </div>

                <a href={contentTypeSlug !== null ? `/${contentTypeSlug}/${slug}` : item?.slug} aria-label={`Read more about ${item?.title}`} role="link" class="w-fit text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Read More
                    <svg aria-hidden="true" class="w-5 h-5 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                </a> 
            </div>
        </div>
    )
}